import o from "./index196.js";
/* empty css         */
import t from "./index130.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-861342c5"]]);
export {
  m as default
};
